import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const getWords = (params) => client.get("/words", { params }).then((r) => r.data);
export const getWord = (id) => client.get(`/words/${id}`).then((r) => r.data);
export const getWordOfTheDay = () => client.get("/word-of-the-day").then((r) => r.data);
export const getCategories = () => client.get("/categories").then((r) => r.data);
export const getProverbs = (params) => client.get("/proverbs", { params }).then((r) => r.data);
export const getProverbOfTheDay = () => client.get("/proverb-of-the-day").then((r) => r.data);
export const getRegions = () => client.get("/regions").then((r) => r.data);
export const getStats = () => client.get("/stats").then((r) => r.data);
export const getTimeline = () => client.get("/timeline").then((r) => r.data);
export const getMusic = () => client.get("/music").then((r) => r.data);
export const getQuizWords = () => client.get("/quiz-words").then((r) => r.data);
